export enum ApiErrors {
  /*
    Authorization token is invalid if this error occurs.
    In such case even public endpoints will be blocked.
    You need to remove authorization header or use a new one.
  */
  INVALID_TOKEN = 'invalid_token',

  /*
    User wasn't found 
    Occurs in currendUser query
  */
  USER_NOT_FOUND = 'user_not_found',

  /*
    No user in context or its role isn't "USER"
    Occurs in currentUser query
  */
  USER_NO_OR_ROLE = 'no_user_or_role',

  /*
    Happens if idDocumentNumber and idDocumentCountry pair is already used
    Occurs in addUserDetails mutation
  */
  USER_DUPLICATE_PASSPORT = 'user_duplicate_passport',

  /*
    Occurs in signUp mutation
    Happens if provided email is already used.
  */
  USER_DUPLICATE_EMAIL = 'user_duplicate_email',

  /*
    Occurs in updateUser (admin)
    Happens if idNowApproval is set to true and idNowStatus is invalid
  */
  USER_INVALID_IDNOWSTATUS = 'user_invalid_idnowstatus',

  /*
    Occurs in login
    Happens if there is no user found by provided credentials
  */
  USER_INVALID_CREDENTIALS = 'user_invalid_credentials',

  /*
    Occurs in removePayment
    Happens if user is trying to remove default payment
  */
  USER_PAYMENT_DEFAULT = 'user_payment_default',

  /*
    Occurs in removePayment and selectDefaultPayment
    removePayment - Happens if payment wasn't found by provided id
    selectDefaultPayment - Happens if default payment isn't in payment_accounts
  */
  USER_PAYMENT_NOT_FOUND = 'user_payment_not_found',

  /*
    Occurs in selectDefaultPayment
    Happens if current user doesn't have any payments
  */
  USER_PAYMENTS = 'user_payment_accounts',

  /*
    Occurs in newInvestment
    Happens if any of these fields are not true: termsEffectaGmbh or termsFinproAG
  */
  INVEST_TAC_NOT_ACCEPTED = 'invest_tac_not_accepted',

  /*
    Occurs in newInvestment
    Happens if desired amount exceeds amount of remining shares.
  */
  INVEST_AMOUNT_EXCEEDS_SHARES = 'invest_amount_exceeds_shares',

  /*
    Occurs in newInvestment
    Happens if desired amount exceeds maximum amount per investment.
  */
  INVEST_AMOUNT_EXCEEDS_MAXIMAL = 'invest_amount_exceeds_max',

  /*
    Occurs in newInvestment
    Happens if desired amount is lower than minimum amount per investment.
  */
  INVEST_AMOUNT_LOWER_MINIMAL = 'invest_amount_lower_min',

  /*
    Occurs in newInvestment
    Happens if user's payment_accounts doesn't include payment_id
  */
  INVEST_NO_PAYMENT = 'invest_payment_not_found',

  /*
    Occurs in confirmInvestment and revokeInvestment
    confirmInvestment - Happens if investment wasn't found by provided id
    revokeInvestment - Happens if investment wasn't found or if it doesn't belong to current user
  */
  INVEST_NOT_FOUND = 'invest_not_found',

  /*
    Occurs in confirmInvestment
    Happens if investment doesn't belong to current user
  */
  INVEST_UNAUTHORIZED_USER = 'invest_unauthorized_user',

  /*
    Occurs in confirmInvestment and acceptInvestment
    Happens if current user isn't whitelisted
  */
  INVEST_USER_WHITELIST = 'invest_user_not_whitelisted',

  /*
    Occurs in acceptInvestment
    Happens if investment status isn't approved
  */
  INVEST_INVALID_STATUS = 'invest_invalid_status',

  /*
    Occurs in rejectInvestment
    Happens if investment status isn't confirmed
  */
  INVEST_REJECT_INVALID_STATUS = 'invest_reject_invalid_status',

  /*
    Occurs in revokeInvestment
    Happens if investment is older than 14 days
  */
  INVEST_TOO_OLD = 'invest_too_old',

  /*
    Occurs in newInvestment
    Happens if provided sale doesn't have price defined
  */
  INVEST_INVALID_SALE = 'invest_invalid_sale',

  /*
    Occurs in getToken
    Happens if token wasn't found by provided id 
  */
  TOKEN_NOT_FOUND = 'token_not_found',

  /*
    Occurs in newToken
    Happens if provided name is already used
  */
  TOKEN_NAME_TAKEN = 'token_name_taken',

  /*
    Occurs in newToken
    Happens if provided symbol is already used
  */
  TOKEN_SYMBOL_TAKEN = 'token_symbol_taken',

  /*
    Occurs in adminSignup
    Happens if admin_password is incorrect
  */
  ADMIN_INVALID_KEY = 'admin_invalid_key',

  /*
    Occurs in adminLogin
    Happens if username is incorrect
  */
  ADMIN_NOT_FOUND = 'admin_not_found',

  /*
    Occurs in adminLogin
    Happens if password is incorrect
  */
  ADMIN_INVALID_PASSWORD = 'admin_invalid_password',
}
